import { render } from "./OtherButton.vue?vue&type=template&id=66445ba7&ts=true"
import script from "./OtherButton.vue?vue&type=script&lang=ts"
export * from "./OtherButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__